const insuranceRulesResources = {
  en: {
    insuranceRules: {
      title: 'Insurance rules',
      'acc1.title': 'Compulsory insurance',
      'acc1.text1':
        'Compulsory insurance of civil liability of owners of facilities whose activity is associated with the risk of harm to third persons',
      'acc1.text1.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dangerous-objects_ru.pdf',
      'acc1.text2': 'Compulsory insurance of civil liability of vehicle owners',
      'acc1.text2.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/EN/ogpovts_en.pdf',
      'acc1.text4':
        'Изменения и дополнения в Правилам обязательного страхования гражданско-правовой ответственности владельцев транспортных средств (с 01.01.2025)',
      'acc1.text4.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_ogpovts_ru.pdf',
      'acc1.text3':
        'Compulsory insurance of civil liability of the carrier to passengers',
      'acc1.text3.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpopp_ru.pdf',
      'acc1.text5': 'Mandatory environmental insurance',
      'acc1.text5.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpoEco2021_ru.pdf',
      'acc2.title': 'Voluntary insurance',
      'acc2.text1': 'Правила добровольного страхования от несчастных случаев',
      'acc2.text1.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/2021_accident_ru.pdf',
      'acc2.text8': '"Tumar" voluntary accident insurance rules',
      'acc2.text8.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/EN/tumar_en.pdf',
      'acc2.text9': 'Rules of voluntary insurance of persons traveling abroad',
      'acc2.text9.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/EN/dmst_eng_28_08_2024.pdf',
      'acc2.text12':
        'Правила добровольного страхования гражданско-правовой ответственности владельцев транспортных средств',
      'acc2.text12.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dgpro_rules_ru.pdf',
      'acc2.text15':
        'Правила Добровольного Страхования автомобильного транспорта',
      'acc2.text15.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/Rules_for_voluntary_motor_transport_insurance_26_07_2024_RU.pdf',
      'acc2.text16':
        'Правила добровольного страхования ГПО перед соседями «Соседи» (от 19.09.2014)',
      'acc2.text16.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/rules_DGPO_neighbours_RU_19.09.2014.pdf',
      'acc2.text17':
        'Дополнения к Правилам добровольного страхования ГПО перед соседями «Соседи» (от 26.12.2018)',
      'acc2.text17.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_DGPO_neighbours_RU_26.12.2018.pdf',
      'acc2.text18':
        'Дополнения к Правилам добровольного страхования от несчастных случаев (от 31.06.2023)',
      'acc2.text18.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_accident_2023_ru.pdf',
      'acc2.text20':
        'Дополнения к правилам добровольного страхования от несчастных случаев “Tumar” (от 31.03.2023)',
      'acc2.text20.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_tumar_31.03.2023.pdf',

      'acc2.text23': 'Правила добровольного титульного страхования',
      'acc2.text23.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/title_rules.pdf',
      'acc2.text24':
        'Дополнения к Правилам добровольного титульного страхования (от 31.03.2023)',
      'acc2.text24.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_title_rules_ru.pdf',
      'acc2.text25': 'Правила добровольного страхования судебных расходов',
      'acc2.text25.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/legal_expenses_rules_ru.pdf',
      'acc2.text26':
        'Правила добровольного страхования гарантий и поручительств',
      'acc2.text26.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/garanty_rules_ru.pdf',
      'acc2.text27':
        'Правила добровольного страхования гражданско-правовой ответственности хлебоприемного предприятия перед держателями зерновых расписок',
      'acc2.text27.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/zerno_rules_ru.pdf',

      /// https://jgarant.atlassian.net/browse/NXIK-279
      'acc2.text30': 'Правила добровольного страхования имущества',
      'acc2.text30.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/property_plus_rules.pdf',

      'acc2.text31':
        'Изменения к Правилам добровольного страхования имущества (07.07.2015г.)',
      'acc2.text31.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_07.07.2015.pdf',

      'acc2.text32':
        'Изменения и дополнения к Правилам добровольного страхования имущества (18.04.2017г.)',
      'acc2.text32.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_18.04.2017.pdf',

      'acc2.text33':
        'Изменения к Правилам добровольного страхования имущества (26.12.2018г.)',
      'acc2.text33.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_26.12.2018.pdf',

      'acc2.text34':
        'Изменения к Правилам добровольного страхования имущества (03.04.2023г.)',
      'acc2.text34.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_03.04.2023.pdf',

      /// --------
      'acc3.title': 'Утратившие силу',
      'acc3.text1':
        'Обязательное страхование гражданско-правовой ответственности владельцев транспортных средств (действовали до 14.10.2024г., включительно)',
      'acc3.text1.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpovts_ru_14.10.24.pdf',
      'acc3.text2':
        'Изменения и дополнения в Правила обязательного страхования гражданско-правовой ответственности владельцев транспортных средств (действовали до 14.10.2024г., включительно)',
      'acc3.text2.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_ogpovts_ru_14.10.24.pdf',
      'acc3.text3':
        'Обязательное страхование гражданско-правовой ответственности перевозчика перед пассажирами (действовали до 02.04.2023г., включительно)',
      'acc3.text3.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpopp_ru_02.04.23.pdf',
      'acc3.text4':
        'Обязательное страхование гражданско-правовой ответственности владельцев объектов, деятельность которых связана с опасностью причинения вреда третьим лицам (действовали до 02.04.2023г., включительно)',
      'acc3.text4.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dangerous-objects_ru_02.04.23.pdf',
      'acc3.text5':
        'Обязательное экологическое страхование (действовали до 14.10.2024г., включительно)',
      'acc3.text5.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpoeco_ru_14.10.24.pdf',
      'acc3.text6':
        'Правила добровольного страхования от несчастных случаев (действовали до 19.09.2021г., включительно)',
      'acc3.text6.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/accidents_ru_19.09.21.pdf',
      'acc3.text7':
        'Изменения к Правилам добровольного страхования от несчастных случаев (действовали до 19.09.2021г., включительно)',
      'acc3.text7.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_accidents_ru_19.09.21.pdf',
      'acc3.text8':
        'Правила добровольного страхования лиц, выезжающих за границу (действовали до 27.08.2024г., включительно)',
      'acc3.text8.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/EN/dmst_en_27.08.24.pdf',
      'acc3.text9':
        'Изменения к Правилам добровольного страхования лиц, выезжающих за границу (действовали до 27.08.2024г., включительно)',
      'acc3.text9.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/EN/changes_dmst_en_27.08.24.pdf',
      'acc3.text10':
        'Правила добровольного страхования гражданско-правовой ответственности владельцев транспортных средств (действовали до 20.06.2024г., включительно)',
      'acc3.text10.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dgpo_ru_20.06.24.pdf',
      'acc3.text11':
        'Изменения к Правилам добровольного страхования гражданско-правовой ответственности владельцев транспортных средств (действовали до 20.06.2024г., включительно)',
      'acc3.text11.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_dgpo_ru_20.06.24.pdf',
      'acc3.text12':
        'Правила Добровольного Страхования автомобильного транспорта (действовали до 25.07.2024г., включительно)',
      'acc3.text12.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/Rules_for_voluntary_motor_transport_insurance_ru_25.07.24.pdf',
      'acc3.text13':
        'Изменения к Правилам Добровольного Страхования автомобильного транспорта (действовали до 25.07.2024г., включительно)',
      'acc3.text13.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_rules_for_voluntary_motor_transport_insurance_ru_25.07.24.pdf',
      'acc3.text14':
        'Правила добровольного титульного страхования (действовали до 28.10.2021г., включительно)',
      'acc3.text14.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/title_ru_28.10.21.pdf',
      'acc3.text15':
        'Изменения к Правилам добровольного титульного страхования (действовали до 28.10.2021г., включительно)',
      'acc3.text15.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_title_ru_28.10.21.pdf',

      'acc3.text16':
        'Правила добровольного страхования гражданско-правовой ответственности хлебоприемного предприятия перед держателями зерновых расписок (действовали до 13.02.2025г., включительно)',
      'acc3.text16.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/zerno_ru_13.02.25.pdf',

      'acc3.text17':
        'Изменения в Правила добровольного страхования гражданско-правовой ответственности хлебоприемного предприятия перед держателями зерновых расписок (действовали до 13.02.2025г., включительно)',
      'acc3.text17.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_zerno_ru_13.02.25.pdf',

      'acc3.text18':
        'Правила добровольного страхования гарантий и поручительств (действовали до 13.02.2025г., включительно)',
      'acc3.text18.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/garanty_rules_ru_13.02.25.pdf',

      'acc3.text19':
        'Изменения в Правила добровольного страхования гарантий и поручительств (действовали до 13.02.2025г., включительно)',
      'acc3.text19.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_garanty_rules_ru_13.02.25.pdf',

      'acc3.text20':
        'Изменения в Правила добровольного страхования гарантий и поручительств (действовали до 13.02.2025г., включительно)',
      'acc3.text20.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes1_garanty_rules_ru_13.02.25.pdf',

      'acc3.text21':
        'Правила добровольного страхования судебных расходов (действовали до 13.02.2025г., включительно)',
      'acc3.text21.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/legal_expenses_rules_ru_13.02.25.pdf',

      'acc3.text22':
        'Изменения в Правила добровольного страхования судебных расходов (действовали до 13.02.2025г., включительно)',
      'acc3.text22.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_legal_expenses_rules_ru_13.02.25.pdf',

      'acc3.text23':
        'Изменения в Правила добровольного страхования судебных расходов (действовали до 13.02.2025г., включительно)',
      'acc3.text23.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes1_legal_expenses_rules_ru_13.02.25.pdf',
    },
  },
  kz: {
    insuranceRules: {
      title: 'Сақтандыру қағидалары',
      'acc1.title': 'Міндетті сақтандыру',
      'acc1.text1':
        'Қызметі үшінші тұлғаларға зиян келтіру қаупімен байланысты, объекті иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру',
      'acc1.text1.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/dangerous-objects_kz_2025.pdf',
      'acc1.text2':
        'Көлік құралдары иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру',
      'acc1.text2.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/ogpovts_kz_2025.pdf',
      // 'acc1.text4':
      //   'Көлік құралдары иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру қағидаларына өзгерістер мен толықтырулар (01.01.2025 бастап)',
      // 'acc1.text4.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_ogpovts_kz.pdf',
      'acc1.text3':
        'Тасымалдаушының жолаушылар алдындағы азаматтық-құқықтық жауапкершілігін міндетті сақтандыру ',
      'acc1.text3.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/ogpopp_kz_2025.pdf',
      'acc1.text5': 'Міндетті экологиялық сақтандыру',
      'acc1.text5.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/ogpoEco_kz_2025.pdf',
      'acc2.title': 'Ерікті сақтандыру',
      'acc2.text1': 'Жазатайым оқиғалардан ерікті сақтандыру ережелері',
      'acc2.text1.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/accident_kz_2025.pdf',
      'acc2.text8':
        '«Tumar» жазатайым оқиғалардан ерікті сақтандыру қағидалары',
      'acc2.text8.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/tumar_kz_2025.pdf',
      'acc2.text9': 'Шетелге шығатын тұлғаларды ерікті сақтандыру ЕРЕЖЕСІ',
      'acc2.text9.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/dmst_kz_2025.pdf',
      'acc2.text12':
        'Көлік құралы иелерінің азаматтық-құқықтық жауапкершілігін ерікті сақтандыру қағидалары',
      'acc2.text12.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/dgpro_rules_kz_2025.pdf',
      'acc2.text15': 'Автомобиль көлігін ерікті сақтандыру ережесі',
      'acc2.text15.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/Rules_for_voluntary_motor_transport_insurance_kz_2025.pdf',
      'acc2.text16':
        '«Көршілер» көршілер алдындағы азаматтық-құқықтық жауапкершілікті ерікті сақтандыру қағидалары',
      'acc2.text16.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/rules_DGPO_neighbours_KZ_2025.pdf',
      // 'acc2.text17':
      //   'Көршілер алдындағы азаматтық-құқықтық жауапкершілікті ерікті сақтандыру қағидаларына өзгерістер 26.12.2018',
      // 'acc2.text17.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_DGPO_neighbours_KZ_26.12.2018.pdf',
      // 'acc2.text18':
      //   'Жазатайым оқиғалардан ерікті сақтандыру ережелеріне өзгерістер мен толықтыру (31.06.2023)',
      // 'acc2.text18.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/accident_changes_kz_31_06_2023.pdf',
      // 'acc2.text20':
      //   '«Tumar» жазатайым оқиғадан ерікті сақтандыру қағидаларына өзгерістер мен толықтыру (31.03.2023)',
      // 'acc2.text20.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_tumar_31.03.2023_kz.pdf',
      'acc2.text23': 'Ерікті титулдық сақтандыру ережелерi',
      'acc2.text23.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/title_rules_kz_2025.pdf',
      // 'acc2.text24':
      //   'Ерікті титулдық сақтандыру қағидаларына өзгерістер 31.03.2023',
      // 'acc2.text24.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_title_rules_kz.pdf',
      'acc2.text25': 'Сот шығыстарынан ерікті сақтандыру қағидалары',
      'acc2.text25.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/legal_expenses_rules_kz_2025.pdf',
      'acc2.text26':
        'Кепілдіктер мен кепілгерліктерді ерікті сақтандыру қағидалары',
      'acc2.text26.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/guarantee_rules_kz_2025.pdf',
      'acc2.text27':
        'Астық қолхаттарын ұстаушылар алдындағы астық қабылдау кәсіпорнының азаматтық-құқықтық жауапкершілігін ерікті сақтандыру қағидалары',
      'acc2.text27.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/zerno_rules_kz_2025.pdf',

      /// https://jgarant.atlassian.net/browse/NXIK-279
      'acc2.text30': 'Мүлікті ерікті сақтандыру қағидалары',
      'acc2.text30.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/property_plus_rules_kz_2025.pdf',

      // 'acc2.text31':
      //   'Мүлікті ерікті сақтандыру қағидаларына өзгерістер (07.07.2015ж.)',
      // 'acc2.text31.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_property_rules_kz_07.07.2015.pdf',

      // 'acc2.text32':
      //   'Мүлікті ерікті сақтандыру қағидаларына өзгерістер мен толықтырулар (18.04.2017ж.)',
      // 'acc2.text32.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_property_rules_kz_18.04.2017.pdf',

      // 'acc2.text33':
      //   'Мүлікті ерікті сақтандыру қағидаларына өзгерістер (26.12.2018ж.)',
      // 'acc2.text33.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_property_rules_kz_26.12.2018.pdf',

      // 'acc2.text34':
      //   'Мүлікті ерікті сақтандыру қағидаларына өзгерістер (03.04.2023ж.)',
      // 'acc2.text34.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_property_rules_kz_03.04.2023.pdf',
      'acc2.text35':
        '«TI» автомобиль көлігін ерікті ортақ сақтандыру жөніндегі сақтандыру ережелері',
      'acc2.text35.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/co-insurance_rules_of_motor_vehicles_TI_kz.pdf',
      'acc2.text36':
        '«SAFE» автокөлік құралдары иелерінің жауапкершілігін ерікті түрде ортақ сақтандыру жөніндегі сақтандыру ережелері',
      'acc2.text36.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/rules_co-insurance_SAFE_kz.pdf',
      'acc2.text37':
        '«BARYS» автомобиль көлігін ерікті сақтандырудың ҚАҒИДАЛАРЫ',
      'acc2.text37.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/barys_rules_kz_2025.pdf',

      /// --------

      'acc3.title': 'Күші жойылған сақтандыру ережелері',
      'acc1.text1.lost':
        'Қызметі үшінші тұлғаларға зиян келтіру қаупімен байланысты, объекті иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc1.text1.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/dangerous-objects_kz.pdf',
      'acc1.text2.lost':
        'Көлік құралдары иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc1.text2.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/ogpovts_kz.pdf',
      'acc1.text4.lost':
        'Көлік құралдары иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру қағидаларына өзгерістер мен толықтырулар (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc1.text4.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_ogpovts_kz.pdf',
      'acc1.text3.lost':
        'Тасымалдаушының жолаушылар алдындағы азаматтық-құқықтық жауапкершілігін міндетті сақтандыру (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc1.text3.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/ogpopp_kz.pdf',
      'acc1.text5.lost':
        'Міндетті экологиялық сақтандыру (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc1.text5.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/ogpoEco2021_kz.pdf',
      'acc2.text1.lost':
        'Жазатайым оқиғалардан ерікті сақтандыру ережелері (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text1.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/accident2021.pdf',
      'acc2.text8.lost':
        '«Tumar» жазатайым оқиғалардан ерікті сақтандыру қағидалары (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text8.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/tumar_kz.pdf',
      'acc2.text9.lost':
        'Шетелге шығатын тұлғаларды ерікті сақтандыру ЕРЕЖЕСІ (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text9.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/dmst_kz_28_08_2024.pdf',

      'acc2.text12.lost':
        'Көлік құралы иелерінің азаматтық-құқықтық жауапкершілігін ерікті сақтандыру қағидалары (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text12.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/dgpro_rules_kz.pdf',
      'acc2.text15.lost':
        'Автомобиль көлігін ерікті сақтандыру ережесі (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text15.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/Rules_for_voluntary_motor_transport_insurance_26_07_2024_KZ.pdf',
      'acc2.text16.lost':
        '«Көршілер» көршілер алдындағы азаматтық-құқықтық жауапкершілікті ерікті сақтандыру қағидалары (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text16.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/rules_DGPO_neighbours_KZ_19.09.2014.pdf',
      'acc2.text17.lost':
        'Көршілер алдындағы азаматтық-құқықтық жауапкершілікті ерікті сақтандыру қағидаларына өзгерістер (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text17.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_DGPO_neighbours_KZ_26.12.2018.pdf',
      'acc2.text18.lost':
        'Жазатайым оқиғалардан ерікті сақтандыру ережелеріне өзгерістер мен толықтыру (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text18.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/accident_changes_kz_31_06_2023.pdf',
      'acc2.text20.lost':
        '«Tumar» жазатайым оқиғадан ерікті сақтандыру қағидаларына өзгерістер мен толықтыру (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text20.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_tumar_31.03.2023_kz.pdf',

      'acc2.text23.lost':
        'Ерікті титулдық сақтандыру ережелерi (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text23.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/title_rules_kz.pdf',
      'acc2.text24.lost':
        'Ерікті титулдық сақтандыру қағидаларына өзгерістер (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text24.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_title_rules_kz.pdf',
      'acc2.text25.lost':
        'Сот шығыстарынан ерікті сақтандыру қағидалары (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text25.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/legal_expenses_rules_kz.pdf',
      'acc2.text26.lost':
        'Кепілдіктер мен кепілгерліктерді ерікті сақтандыру қағидалары (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text26.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/garanty_rules_kz.pdf',
      'acc2.text27.lost':
        'Астық қолхаттарын ұстаушылар алдындағы астық қабылдау кәсіпорнының азаматтық-құқықтық жауапкершілігін ерікті сақтандыру қағидалары (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text27.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/zerno_rules_kz.pdf',

      'acc2.text30.lost':
        'Мүлікті ерікті сақтандыру қағидалары (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text30.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/property_plus_rules_kz.pdf',

      'acc2.text31.lost':
        'Мүлікті ерікті сақтандыру қағидаларына өзгерістер (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text31.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_property_rules_kz_07.07.2015.pdf',

      'acc2.text32.lost':
        'Мүлікті ерікті сақтандыру қағидаларына өзгерістер мен толықтырулар (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text32.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_property_rules_kz_18.04.2017.pdf',

      'acc2.text33.lost':
        'Мүлікті ерікті сақтандыру қағидаларына өзгерістер (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text33.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_property_rules_kz_26.12.2018.pdf',

      'acc2.text34.lost':
        'Мүлікті ерікті сақтандыру қағидаларына өзгерістер (2025 ж. 11 тамазына дейін жарамды, қоса алғанда)',
      'acc2.text34.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_property_rules_kz_03.04.2023.pdf',
      'acc3.text1':
        'Көлік құралдары иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру (2024 ж. 14 қазанына дейін жарамды, қоса алғанда)',
      'acc3.text1.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/ogpovts_kz_14.10.24.pdf',
      'acc3.text2':
        'Көлік құралдары иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру қағидаларына өзгерістер мен толықтырулар (2024 ж. 14 қазанына дейін жарамды, қоса алғанда)',
      'acc3.text2.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_ogpovts_kz_14.10.24.pdf',
      'acc3.text3':
        'Тасымалдаушының жолаушылар алдындағы азаматтық-құқықтық жауапкершілігін міндетті сақтандыру (2023 ж. 2 сәуірін дейін жарамды, қоса алғанда)',
      'acc3.text3.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/ogpopp_kz_02.04.23.pdf',
      'acc3.text4':
        'Қызметі үшінші тұлғаларға зиян келтіру қаупімен байланысты, объекті иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру (2023 ж. 2 сәуірін дейін жарамды, қоса алғанда)',
      'acc3.text4.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/dangerous-objects_kz_02.04.23.pdf',
      'acc3.text5':
        'Міндетті экологиялық сақтандыру (2024 ж. 14 қазанына дейін жарамды, қоса алғанда)',
      'acc3.text5.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/ogpoeco_kz_14.10.24.pdf',
      'acc3.text6':
        'Жазатайым оқиғалардан ерікті сақтандыру ережелері (2021 ж. 19 қыркүйегіне дейін жарамды, қоса алғанда)',
      'acc3.text6.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/accidents_kz_19.09.21.pdf',
      'acc3.text7':
        'Жазатайым оқиғалардан ерікті сақтандыру ережелеріне өзгерістер мен толықтыру (2021 ж. 19 қыркүйегіне дейін жарамды, қоса алғанда)',
      'acc3.text7.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_accidents_kz_19.09.21.pdf',
      'acc3.text8':
        'Шетелге шығатын адамдарды ерікті сақтандыру қағидалары (2024 ж. 27 тамызын дейін жарамды, қоса алғанда)',
      'acc3.text8.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/dmst_kz_27.08.24.pdf',
      'acc3.text9':
        'Шетелге шығатын тұлғаларды ерікті сақтандыру қағидаларына өзгерістер (2024 ж. 27 тамызын дейін жарамды, қоса алғанда)',
      'acc3.text9.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_dmst_kz_27.08.24.pdf',
      'acc3.text10':
        'Көлік құралы иелерінің азаматтық-құқықтық жауапкершілігін ерікті сақтандыру қағидалары (2024 ж. 20 маусымына дейін жарамды, қоса алғанда)',
      'acc3.text10.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/dgpo_kz_20.06.24.pdf',
      'acc3.text11':
        'Көлік құралдары иелерінің азаматтық-құқықтық жауапкершілігін ерікті сақтандыру қағидаларына өзгерістер (2024 ж. 20 маусымына дейін жарамды, қоса алғанда)',
      'acc3.text11.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_dgpo_kz_20.06.24.pdf',
      'acc3.text12':
        'Автомобиль көлігін ерікті сақтандыру ережесі (2024 ж. 25 шілдесіне дейін жарамды, қоса алғанда)',
      'acc3.text12.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/Rules_for_voluntary_motor_transport_insurance_kz_25.07.24.pdf',
      'acc3.text13':
        'Автомобиль көлігін ерікті сақтандыру қағидаларына өзгерістер (2024 ж. 25 шілдесіне дейін жарамды, қоса алғанда)',
      'acc3.text13.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_rules_for_voluntary_motor_transport_insurance_kz_25.07.24.pdf',
      'acc3.text14':
        'Ерікті титулдық сақтандыру қағидалары (2021 ж. 28 қазанына дейін жарамды, қоса алғанда)',
      'acc3.text14.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/title_kz_28.10.21.pdf',
      'acc3.text15':
        'Ерікті титулдық сақтандыру қағидаларына өзгерістер (2021 ж. 28 қазанына дейін жарамды, қоса алғанда)',
      'acc3.text15.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_title_kz_28.10.21.pdf',

      'acc3.text16':
        'Астық қолхаттарын ұстаушылар алдындағы астық қабылдау кәсіпорнының азаматтық-құқықтық жауапкершілігін ерікті сақтандыру қағидалары (2025 ж. 13 ақпанына дейін жарамды, қоса алғанда)',
      'acc3.text16.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/zerno_kz_13.02.25.pdf',

      'acc3.text17':
        'Астық қолхаттарын ұстаушылар алдындағы астық қабылдау кәсіпорнының азаматтық-құқықтық жауапкершілігін ерікті сақтандыру қағидаларына өзгерістер (2025 ж. 13 ақпанына дейін жарамды, қоса алғанда)',
      'acc3.text17.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_zerno_kz_13.02.25.pdf',

      'acc3.text18':
        'Кепілдіктер мен кепілгерліктерді ерікті сақтандыру қағидалары (2025 ж. 13 ақпанына дейін жарамды, қоса алғанда)',
      'acc3.text18.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/garanty_rules_kz_13.02.25.pdf',

      'acc3.text19':
        'Кепілдіктер мен кепілгерліктерді ерікті сақтандыру қағидаларына өзгерістер (2025 ж. 13 ақпанына дейін жарамды, қоса алғанда)',
      'acc3.text19.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_garanty_rules_kz_13.02.25.pdf',

      'acc3.text20':
        'Кепілдіктер мен кепілгерліктерді ерікті сақтандыру қағидаларына өзгерістер (2025 ж. 13 ақпанына дейін жарамды, қоса алғанда)',
      'acc3.text20.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes1_garanty_rules_kz_13.02.25.pdf',

      'acc3.text21':
        'Сот шығыстарынан ерікті сақтандыру қағидалары (2025 ж. 13 ақпанына дейін жарамды, қоса алғанда)',
      'acc3.text21.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/legal_expenses_rules_kz_13.02.25.pdf',

      'acc3.text22':
        'Сот шығыстарынан ерікті сақтандыру қағидаларына өзгерістер (2025 ж. 13 ақпанына дейін жарамды, қоса алғанда)',
      'acc3.text22.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes_legal_expenses_rules_kz_13.02.25.pdf',

      'acc3.text23':
        'Сот шығыстарынан ерікті сақтандыру қағидаларына өзгерістер (2025 ж. 13 ақпанына дейін жарамды, қоса алғанда)',
      'acc3.text23.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/KZ/changes1_legal_expenses_rules_kz_13.02.25.pdf',
    },
  },
  ru: {
    insuranceRules: {
      title: 'Правила страхования',
      'acc1.title': 'Обязательное страхование',
      'acc1.text1':
        'Обязательное страхование гражданско-правовой ответственности владельцев объектов, деятельность которых связана с опасностью причинения вреда третьим лицам',
      'acc1.text1.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dangerous-objects_ru_2025.pdf',
      'acc1.text2':
        'Обязательное страхование гражданско-правовой ответственности владельцев транспортных средств',
      'acc1.text2.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpovts_ru_2025.pdf',
      // 'acc1.text4':
      //   'Изменения и дополнения в Правилам обязательного страхования гражданско-правовой ответственности владельцев транспортных средств (с 01.01.2025)',
      // 'acc1.text4.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_ogpovts_ru.pdf',
      'acc1.text3':
        'Обязательное страхование гражданско-правовой ответственности перевозчика перед пассажирами',
      'acc1.text3.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpopp_ru_2025.pdf',
      'acc1.text5': 'Обязательное экологическое страхование',
      'acc1.text5.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpoEco_ru_2025.pdf',
      'acc2.title': 'Добровольное страхование',
      'acc2.text1': 'Правила добровольного страхования от несчастных случаев',
      'acc2.text1.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/rules_accident_ru_2025.pdf',
      'acc2.text8':
        'Правила добровольного страхования от несчастных случаев «Tumar»',
      'acc2.text8.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/tumar_ru_2025.pdf ',
      'acc2.text9':
        'Правила добровольного страхования лиц, выезжающих за границу',
      'acc2.text9.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dmst_ru_2025.pdf',
      'acc2.text12':
        'Правила добровольного страхования гражданско-правовой ответственности владельцев транспортных средств',
      'acc2.text12.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dgpro_rules_ru_2025.pdf',
      'acc2.text15':
        'Правила Добровольного Страхования автомобильного транспорта',
      'acc2.text15.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/Rules_for_voluntary_motor_transport_insurance_ru_2025.pdf',
      'acc2.text16':
        'Правила добровольного страхования ГПО перед соседями «Соседи»',
      'acc2.text16.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/rules_DGPO_neighbours_ru_2025.pdf',
      // 'acc2.text17':
      //   'Дополнения к Правилам добровольного страхования ГПО перед соседями «Соседи» (от 26.12.2018)',
      // 'acc2.text17.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_DGPO_neighbours_RU_26.12.2018.pdf',
      // 'acc2.text18':
      //   'Дополнения к Правилам добровольного страхования от несчастных случаев (от 31.06.2023)',
      // 'acc2.text18.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_accident_2023_ru.pdf',
      // 'acc2.text20':
      //   'Дополнения к правилам добровольного страхования от несчастных случаев “Tumar” (от 31.03.2023)',
      // 'acc2.text20.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_tumar_31.03.2023.pdf',

      'acc2.text23': 'Правила добровольного титульного страхования',
      'acc2.text23.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/title_rules_ru_2025.pdf',
      // 'acc2.text24':
      //   'Дополнения к Правилам добровольного титульного страхования (от 31.03.2023)',
      // 'acc2.text24.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_title_rules_ru.pdf',
      'acc2.text25': 'Правила добровольного страхования судебных расходов',
      'acc2.text25.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/legal_expenses_rules_ru_2025.pdf',
      'acc2.text26':
        'Правила добровольного страхования гарантий и поручительств',
      'acc2.text26.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/garanty_rules_ru_2025.pdf',
      'acc2.text27':
        'Правила добровольного страхования гражданско-правовой ответственности хлебоприемного предприятия перед держателями зерновых расписок',
      'acc2.text27.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/zerno_rules_ru_2025.pdf',
      'acc2.text30': 'Правила добровольного страхования имущества',
      'acc2.text30.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/property_plus_rules_ru_2025.pdf',

      // 'acc2.text31':
      //   'Изменения к Правилам добровольного страхования имущества (07.07.2015г.)',
      // 'acc2.text31.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_07.07.2015.pdf',

      // 'acc2.text32':
      //   'Изменения и дополнения к Правилам добровольного страхования имущества (18.04.2017г.)',
      // 'acc2.text32.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_18.04.2017.pdf',

      // 'acc2.text33':
      //   'Изменения к Правилам добровольного страхования имущества (26.12.2018г.)',
      // 'acc2.text33.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_26.12.2018.pdf',

      // 'acc2.text34':
      //   'Изменения к Правилам добровольного страхования имущества (03.04.2023г.)',
      // 'acc2.text34.url':
      //   'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_03.04.2023.pdf',
      'acc2.text35':
        'Правила страхования по добровольному сострахованию автомобильного транспорта «TI»',
      'acc2.text35.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/co-insurance_rules_of_motor_vehicles_TI_ru.pdf',
      'acc2.text36':
        'Правила страхования по добровольному сострахованию ответственности владельцев автотранспортных средств «SAFE»',
      'acc2.text36.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/rules_co-insurance_SAFE_ru.pdf',
      'acc2.text37':
        'Правила добровольного страхования автомобильного транспорта «BARYS»',
      'acc2.text37.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/barys_rules_ru_2025.pdf',

      /// --------

      'acc3.title': 'Утратившие силу',
      'acc1.text1.lost':
        'Обязательное страхование гражданско-правовой ответственности владельцев объектов, деятельность которых связана с опасностью причинения вреда третьим лицам (действовали до 11.08.2025г., включительно)',
      'acc1.text1.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dangerous-objects_ru.pdf',
      'acc1.text2.lost':
        'Обязательное страхование гражданско-правовой ответственности владельцев транспортных средств (действовали до 11.08.2025г., включительно)',
      'acc1.text2.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpovts_ru.pdf',
      'acc1.text4.lost':
        'Изменения и дополнения в Правилам обязательного страхования гражданско-правовой ответственности владельцев транспортных средств (действовали до 11.08.2025г., включительно)',
      'acc1.text4.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_ogpovts_ru.pdf',
      'acc1.text3.lost':
        'Обязательное страхование гражданско-правовой ответственности перевозчика перед пассажирами (действовали до 11.08.2025г., включительно)',
      'acc1.text3.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpopp_ru.pdf',
      'acc1.text5.lost':
        'Обязательное экологическое страхование (действовали до 11.08.2025г., включительно)',
      'acc1.text5.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpoEco2021_ru.pdf',
      'acc2.text1.lost':
        'Правила добровольного страхования от несчастных случаев (действовали до 11.08.2025г., включительно)',
      'acc2.text1.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/2021_accident_ru.pdf',
      'acc2.text8.lost':
        'Правила добровольного страхования от несчастных случаев «Tumar» (действовали до 11.08.2025г., включительно)',
      'acc2.text8.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/tumar_ru.pdf',
      'acc2.text9.lost':
        'Правила добровольного страхования лиц, выезжающих за границу (действовали до 11.08.2025г., включительно)',
      'acc2.text9.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dmst_ru_28_08_2024.pdf',
      'acc2.text12.lost':
        'Правила добровольного страхования гражданско-правовой ответственности владельцев транспортных средств (действовали до 11.08.2025г., включительно)',
      'acc2.text12.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dgpro_rules_ru.pdf',
      'acc2.text15.lost':
        'Правила Добровольного Страхования автомобильного транспорта (действовали до 11.08.2025г., включительно)',
      'acc2.text15.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/Rules_for_voluntary_motor_transport_insurance_26_07_2024_RU.pdf',
      'acc2.text16.lost':
        'Правила добровольного страхования ГПО перед соседями «Соседи» (действовали до 11.08.2025г., включительно)',
      'acc2.text16.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/rules_DGPO_neighbours_RU_19.09.2014.pdf',
      'acc2.text17.lost':
        'Дополнения к Правилам добровольного страхования ГПО перед соседями «Соседи» (действовали до 11.08.2025г., включительно)',
      'acc2.text17.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_DGPO_neighbours_RU_26.12.2018.pdf',
      'acc2.text18.lost':
        'Дополнения к Правилам добровольного страхования от несчастных случаев (действовали до 11.08.2025г., включительно)',
      'acc2.text18.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_accident_2023_ru.pdf',
      'acc2.text20.lost':
        'Дополнения к правилам добровольного страхования от несчастных случаев “Tumar” (действовали до 11.08.2025г., включительно)',
      'acc2.text20.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_tumar_31.03.2023.pdf',

      'acc2.text23.lost':
        'Правила добровольного титульного страхования (действовали до 11.08.2025г., включительно)',
      'acc2.text23.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/title_rules.pdf',
      'acc2.text24.lost':
        'Дополнения к Правилам добровольного титульного страхования (действовали до 11.08.2025г., включительно)',
      'acc2.text24.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_title_rules_ru.pdf',
      'acc2.text25.lost':
        'Правила добровольного страхования судебных расходов (действовали до 11.08.2025г., включительно)',
      'acc2.text25.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/legal_expenses_rules_ru.pdf',
      'acc2.text26.lost':
        'Правила добровольного страхования гарантий и поручительств (действовали до 11.08.2025г., включительно)',
      'acc2.text26.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/garanty_rules_ru.pdf',
      'acc2.text27.lost':
        'Правила добровольного страхования гражданско-правовой ответственности хлебоприемного предприятия перед держателями зерновых расписок (действовали до 11.08.2025г., включительно)',
      'acc2.text27.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/zerno_rules_ru.pdf',

      'acc2.text30.lost':
        'Правила добровольного страхования имущества (действовали до 11.08.2025г., включительно)',
      'acc2.text30.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/property_plus_rules.pdf',

      'acc2.text31.lost':
        'Изменения к Правилам добровольного страхования имущества (действовали до 11.08.2025г., включительно)',
      'acc2.text31.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_07.07.2015.pdf',

      'acc2.text32.lost':
        'Изменения и дополнения к Правилам добровольного страхования имущества (действовали до 11.08.2025г., включительно)',
      'acc2.text32.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_18.04.2017.pdf',

      'acc2.text33.lost':
        'Изменения к Правилам добровольного страхования имущества (действовали до 11.08.2025г., включительно)',
      'acc2.text33.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_26.12.2018.pdf',

      'acc2.text34.lost':
        'Изменения к Правилам добровольного страхования имущества (действовали до 11.08.2025г., включительно)',
      'acc2.text34.url.lost':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_property_rules_ru_03.04.2023.pdf',
      'acc3.text1':
        'Обязательное страхование гражданско-правовой ответственности владельцев транспортных средств (действовали до 14.10.2024г., включительно)',
      'acc3.text1.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpovts_ru_14.10.24.pdf',
      'acc3.text2':
        'Изменения и дополнения в Правила обязательного страхования гражданско-правовой ответственности владельцев транспортных средств (действовали до 14.10.2024г., включительно)',
      'acc3.text2.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_ogpovts_ru_14.10.24.pdf',
      'acc3.text3':
        'Обязательное страхование гражданско-правовой ответственности перевозчика перед пассажирами (действовали до 02.04.2023г., включительно)',
      'acc3.text3.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpopp_ru_02.04.23.pdf',
      'acc3.text4':
        'Обязательное страхование гражданско-правовой ответственности владельцев объектов, деятельность которых связана с опасностью причинения вреда третьим лицам (действовали до 02.04.2023г., включительно)',
      'acc3.text4.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dangerous-objects_ru_02.04.23.pdf',
      'acc3.text5':
        'Обязательное экологическое страхование (действовали до 14.10.2024г., включительно)',
      'acc3.text5.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/ogpoeco_ru_14.10.24.pdf',
      'acc3.text6':
        'Правила добровольного страхования от несчастных случаев (действовали до 19.09.2021г., включительно)',
      'acc3.text6.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/accidents_ru_19.09.21.pdf',
      'acc3.text7':
        'Изменения к Правилам добровольного страхования от несчастных случаев (действовали до 19.09.2021г., включительно)',
      'acc3.text7.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_accidents_ru_19.09.21.pdf',
      'acc3.text8':
        'Правила добровольного страхования лиц, выезжающих за границу (действовали до 27.08.2024г., включительно)',
      'acc3.text8.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dmst_ru_27.08.24.pdf',
      'acc3.text9':
        'Изменения к Правилам добровольного страхования лиц, выезжающих за границу (действовали до 27.08.2024г., включительно)',
      'acc3.text9.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_dmst_ru_27.08.24.pdf',
      'acc3.text10':
        'Правила добровольного страхования гражданско-правовой ответственности владельцев транспортных средств (действовали до 20.06.2024г., включительно)',
      'acc3.text10.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/dgpo_ru_20.06.24.pdf',
      'acc3.text11':
        'Изменения к Правилам добровольного страхования гражданско-правовой ответственности владельцев транспортных средств (действовали до 20.06.2024г., включительно)',
      'acc3.text11.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_dgpo_ru_20.06.24.pdf',
      'acc3.text12':
        'Правила Добровольного Страхования автомобильного транспорта (действовали до 25.07.2024г., включительно)',
      'acc3.text12.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/Rules_for_voluntary_motor_transport_insurance_ru_25.07.24.pdf',
      'acc3.text13':
        'Изменения к Правилам Добровольного Страхования автомобильного транспорта (действовали до 25.07.2024г., включительно)',
      'acc3.text13.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_rules_for_voluntary_motor_transport_insurance_ru_25.07.24.pdf',
      'acc3.text14':
        'Правила добровольного титульного страхования (действовали до 28.10.2021г., включительно)',
      'acc3.text14.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/title_ru_28.10.21.pdf',
      'acc3.text15':
        'Изменения к Правилам добровольного титульного страхования (действовали до 28.10.2021г., включительно)',
      'acc3.text15.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_title_ru_28.10.21.pdf',

      'acc3.text16':
        'Правила добровольного страхования гражданско-правовой ответственности хлебоприемного предприятия перед держателями зерновых расписок (действовали до 13.02.2025г., включительно)',
      'acc3.text16.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/zerno_ru_13.02.25.pdf',

      'acc3.text17':
        'Изменения в Правила добровольного страхования гражданско-правовой ответственности хлебоприемного предприятия перед держателями зерновых расписок (действовали до 13.02.2025г., включительно)',
      'acc3.text17.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_zerno_ru_13.02.25.pdf',

      'acc3.text18':
        'Правила добровольного страхования гарантий и поручительств (действовали до 13.02.2025г., включительно)',
      'acc3.text18.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/garanty_rules_ru_13.02.25.pdf',

      'acc3.text19':
        'Изменения в Правила добровольного страхования гарантий и поручительств (действовали до 13.02.2025г., включительно)',
      'acc3.text19.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_garanty_rules_ru_13.02.25.pdf',

      'acc3.text20':
        'Изменения в Правила добровольного страхования гарантий и поручительств (действовали до 13.02.2025г., включительно)',
      'acc3.text20.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes1_garanty_rules_ru_13.02.25.pdf',

      'acc3.text21':
        'Правила добровольного страхования судебных расходов (действовали до 13.02.2025г., включительно)',
      'acc3.text21.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/legal_expenses_rules_ru_13.02.25.pdf',

      'acc3.text22':
        'Изменения в Правила добровольного страхования судебных расходов (действовали до 13.02.2025г., включительно)',
      'acc3.text22.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes_legal_expenses_rules_ru_13.02.25.pdf',

      'acc3.text23':
        'Изменения в Правила добровольного страхования судебных расходов (действовали до 13.02.2025г., включительно)',
      'acc3.text23.url':
        'https://api.jgarant.kz/admin/media/Site/InsuranceRules/RU/changes1_legal_expenses_rules_ru_13.02.25.pdf',
    },
  },
};

export default insuranceRulesResources;
